import {ErrorHandler} from '@angular/core';
import {AwsRum, AwsRumConfig} from 'aws-rum-web';

//TODO let { resolve, reject, promise } = Promise.withResolvers<AwsRum|null>();
let resolve, reject, promise;

promise = new Promise((r, rj) => {
  resolve = r;
  reject = rj;
});


export let rum: Promise<AwsRum|null>|AwsRum|null = promise;

export function disableRum() {
  rum = null;
  if (resolve) {
    resolve(null);
    resolve = null;
    reject = null;
  }
}

export async function enableRum(id: string, region: string, identity?: string) {
  try {
    const { AwsRum } = await import('aws-rum-web');

    const config: AwsRumConfig = {
      allowCookies: true,
      endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
      telemetries: ['performance', 'errors', 'http'],
      sessionSampleRate: 1
    };

    if (identity) {
      config.identityPoolId = identity;
    }

    rum = new AwsRum(id, '1.0.0', region, config);

    if (resolve) {
      resolve(rum);
      resolve = null;
      reject = null;
    }

  } catch (error) {
    console.error(error);
    rum = null;
  }

  return rum;
}

export class RumErrorHandler implements ErrorHandler {
  async handleError(error: any) {
    if (rum instanceof Promise) {
      await rum;
    }

    if (rum) {
      (rum as AwsRum).recordError(error);
    }
  }
}